import React, {
  Component,
  //isValidElement,
  Children,
  createElement
} from "react";
import store from '../../stores/store';


// base class that detects offline/online changes
class Base extends Component {

  renderChildren() {
    const { children } = this.props;
    const { wrapperType = "span" } = this.props;

    // usual case: one child that is a react Element
    if (React.isValidElement(children)) {
      return children;
    }

    // no children
    if (!children) {
      return null;
    }

    // string children, multiple children, or something else
    const childrenArray = Children.toArray(children);
    //const firstChild = childrenArray[0];

    return createElement(wrapperType, {}, ...childrenArray);
  }
}

export class Online extends Base {
  render() {
    return store.conn.isOnline ? this.renderChildren() : null;
  }
}

export class Offline extends Base {
  render() {
    return !store.conn.isOnline ? this.renderChildren() : null;
  }
}

export class Detector extends Base {
  render() {
    return this.props.render({ online: store.conn.isOnline });
  }
}



// WEBPACK FOOTER //
// ./src/containers/_shared/conn.js